const EngineConfig = {
  // current age, whole years
  AgeNow: 45,
  AgeNow_2: 45,

  // retirement age (must be greater or equal to the greater of preservation age or ageNow)
  RetirementAge: 67,
  RetirementAge_2: 67,

  // user salary ($'s / year)
  Salary: 80000,

  // partner's salary ($'s / year)
  Salary_2: 80000,

  // user gender ("Male" / "Female")
  Sex: 'Male',
  Sex_2: 'Female',

  // current super balance
  SuperannuationBalance: 50000,
  SuperannuationBalance_2: 50000,

  // target income (annual drawdown amount during retirement)
  TargetIncome: 50000,
};

export default EngineConfig
